import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import validator from 'validator';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Api } from '../../../smoothr-web-app-core/api/api';
import { Gender } from 'src/smoothr-web-app-core/enums/Gender';

import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthStrategy } from '../../../smoothr-web-app-core/models/AuthStrategy';
import { axiosErrorToMessage, sleep } from '../../../smoothr-web-app-core/utils/utils';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';
import { IonInput, ModalController } from '@ionic/angular';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { countries } from 'src/app/components/input-phone-with-county-code/mock-countries';
import { Company } from 'src/smoothr-web-app-core/models/CompanyCode';
import { AppComponent } from 'src/app/app.component';

@Component({
	selector: 'app-sign-up-modal',
	templateUrl: './sign-up-modal.component.html',
	styleUrls: ['./sign-up-modal.component.scss'],
})
export class SignUpModalComponent implements OnInit {
	public isAccount = false;
	showRePassword = false;
	showPassword = false;
	isValidEmail = true;
	isValidName = true;
	isValidPassword = true;
	isValidRePassword = true;
	venue: Venue;
	email = 'email';
	password = 'password';
	rePassword = 'rePassword';
	name = 'name';
	surname = 'surname';
	agbChecked = 'agbChecked';
	phone = 'phone';
	day = 'day';
	month = 'month';
	year = 'year';
	dnd_codeInvalid = false;
	loading = false;

	signUpForm: FormGroup;

	private readonly subscription: Subscription;

	constructor(
		private translate: TranslateService,
		private router: Router,
		private repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private fb: FormBuilder,
		private navigationService: NavigationService,
		private modalCtrl: ModalController
	) {
		if (repository.customer && !repository.customer.isAnonymous) {
			this.navigationService.account();
		}
	}
	static async show(modalCtrl: ModalController): Promise<void> {
		const modal = await modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'sign-modal' : 'menu-modal',
			component: SignUpModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		this.isAccount = false;
		if (this.router.url.includes('user-data')) {
			this.isAccount = true;
		}
		this.createFormSignUp();
	}

	createFormSignUp() {
		const formControlNames: any = {};
		formControlNames[this.name] = ['', [Validators.required]];
		formControlNames[this.surname] = ['', [Validators.required]];

		if (!this.isAccount) {
			formControlNames[this.email] = [
				'',
				[
					Validators.required,
					Validators.pattern(
						"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
					),
				],
			];
			formControlNames[this.agbChecked] = [false, [Validators.required, Validators.requiredTrue]];
			formControlNames[this.password] = [
				'',
				[Validators.required, Validators.minLength(8), Validators.pattern(/\d+/), Validators.pattern(/[A-Z]+/)],
			];

			formControlNames[this.rePassword] = ['', [Validators.required, this._isPasswordMatch()]];
			formControlNames[this.phone] = [
				{
					country: '+41',
					phone: '',
				},
				[this._customRequiredPhone, this._customPhoneValidatorForLibrary],
			];
			formControlNames[this.day] = ['', [Validators.max(31)]];
			formControlNames[this.month] = ['', [Validators.max(12)]];
			formControlNames[this.year] = ['', [Validators.min(1900)]];
		}

		this.signUpForm = this.fb.group(formControlNames);
		if (this.isAccount) {
			this.patchForm();
		}
	}
	private patchForm() {
		let defaultPhone = {
			country: '+41',
			phone: '',
		};

		if (this.repository && this.repository?.customer && this.repository?.customer?.phone) {
			let countryCode = countries.find(it => this.repository.customer?.phone?.trim().startsWith('+' + it.dialCode));
			defaultPhone = {
				country: '+' + (countryCode?.dialCode || '41'),
				phone: this.repository.customer?.phone
					? this.repository.customer?.phone?.trim()?.replace('+' + countryCode?.dialCode, '')
					: '',
			};
		}
		if (this.isAccount && this.repository.customer) {
			const spreadName = this.repository.customer.name.split(' ');
			this.signUpForm.patchValue({
				gender: this.repository.customer.gender,
				[this.name]: spreadName[0],
				[this.surname]: spreadName[1],
				email: this.repository.customer.email,

				phone: {
					country: defaultPhone.country,
					phone: defaultPhone.phone,
				},
			});
			if (this.repository.customer.birthDate) {
				this.signUpForm.patchValue({
					day: new Date(this.repository.customer.birthDate).getDate(),
					month: new Date(this.repository.customer.birthDate).getMonth() + 1,
					year: new Date(this.repository.customer.birthDate).getFullYear(),
				});
			}
		}
		// this.route.queryParams.subscribe(params => {
		// 	if (params.email || params.name) {
		// 		this.signUpForm.patchValue({
		// 			name: params.name?.split(' ')[0] ?? '',
		// 			vorname: params.name?.split(' ')[1] ?? '',
		// 			email: params.email
		// 		});
		// 	}
		// });
	}
	private _isPasswordMatch(): ValidatorFn {
		return () => {
			const pass = this.signUpForm?.get('password')?.value;
			const confirmPass = this.signUpForm?.get('rePassword')?.value;
			return pass === confirmPass ? null : { notSame: true };
		};
	}
	private _customRequiredPhone(control: AbstractControl) {
		if (!control.value?.phone) {
			return { required: true };
		}

		return null;
	}

	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		if (String(control.value?.phone).length === 1) {
			return { invalidPhone: true };
		}
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

		try {
			const phoneNumber = phoneUtil.parse(control?.value?.country + control?.value?.phone.toString());
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.signUpForm.get(controlName)?.hasError('required') && this.signUpForm.get(controlName)?.touched;
		}

		return this.signUpForm.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.signUpForm.get(controlName)?.errors && !this.signUpForm.get(controlName)?.hasError('required');
		}
		return this.signUpForm.invalid;
	}

	getControlValue(controlName?: string) {
		if (controlName) {
			return this.signUpForm?.get(controlName)?.value;
		}
		return '';
	}

	ngOnDestroy() {
		if (this.subscription && !this.subscription.closed) {
			this.subscription.unsubscribe();
		}
	}
	async update() {
		try {
			this.loading = true;

			const response = await Api.patchCustomer({
				...this.repository.customer,
				name: this.getControlValue(this.name) + ' ' + this.getControlValue(this.surname),

				// email: this.getControlValue('email'),
				preferredVenues: [],
				phone:
					this.getControlValue('phone')?.phone && this.getControlValue('phone')?.country
						? this.getControlValue('phone')?.country + this.getControlValue('phone')?.phone
						: null,
			});

			const mainUser = this.repository._customerAuth;
			mainUser.customer = { ...mainUser.customer, ...response.data };
			this.repository.customerAuth.next(mainUser);
			this.loading = false;
			this.snackbarCtrl.open(this.translate.instant('account.success'), null, {
				duration: 4000,
			});
			// await InformationModalComponent.show(this.modalCtrl, {
			// 	title: this.translate.instant('sign_up.success'),
			// 	info: this.translate.instant('sign_up.updated'),
			// 	closeButton: this.translate.instant('add_points.close')
			// });
		} catch (e) {
			console.log(e);
			this.loading = false;

			if (e?.response?.data?.message) {
				this.snackbarCtrl.open(e.response.data.message, null, {
					duration: 4000,
				});
			} else {
				this.snackbarCtrl.open(this.translate.instant('account.error'), null, {
					duration: 2000,
				});
			}
		}
	}
	async signUp() {
		if (!this.loading) {
			if (!this.signUpForm.valid) {
				this.markFormFieldsAsTouched(this.signUpForm);
				return;
			}

			this.loading = true;
			try {
				const objectToSend = {
					name: this.getControlValue(this.name) + ' ' + this.getControlValue(this.surname),
					gender: Gender.male,
					email: this.getControlValue('email'),
					preferredVenues: [],
					phone:
						this.getControlValue('phone')?.phone && this.getControlValue('phone')?.country
							? this.getControlValue('phone')?.country + this.getControlValue('phone')?.phone
							: null,
					birthDate:
						this.getControlValue(this.year) && this.getControlValue(this.month) && this.getControlValue(this.day)
							? new Date(
									new Date(0).setFullYear(
										this.getControlValue(this.year),
										Number(this.getControlValue(this.month)) - 1,
										this.getControlValue(this.day)
									)
							  ).toString()
							: null,
					registerInPiggy: true,
				};
				// if(company && company?._id) {
				// 	objectToSend.dndCompany
				// }
				await Api.signUpWithCredentials(objectToSend, this.getControlValue('password'));

				await sleep(1000);
				await this.modalCtrl.dismiss();
				await sleep(100);
				await this.navigationService.emailConfirmation();
			} catch (e) {
				if (e.response.data.name === 'UserAlreadyExistsError') {
					this.isValidEmail = false;
				}
				this.snackbarCtrl.open(axiosErrorToMessage(this.translate, e));
			}
			this.loading = false;
		}
	}

	async signIn() {
		await this.navigationService.signIn();
	}

	setEmailValid() {
		this.isValidEmail = true;
	}

	setNameValid() {
		this.isValidName = true;
	}

	setPasswordValid() {
		this.isValidPassword = true;
		this.isValidRePassword = true;
	}

	async signUpWithGoogle() {
		if (this.agbChecked && !this.loading) {
			this.loading = true;
			try {
				console.log('Starting signUp with Google');
				const result = await Api.signIn(AuthStrategy.GOOGLE);
				if (result && result.data) {
					if (AppComponent.largeScreen) {
						window.open(result.data.url, '_blank');
					} else {
						window.location.assign(result.data.url);
					}
				}
			} catch (e) {
				console.error(e);
			}
			this.loading = false;
		}
	}

	async signUpWithFacebook() {
		if (this.agbChecked && !this.loading) {
			this.loading = true;
			try {
				console.log('Starting signUp with Facebook');
				const result = await Api.signIn(AuthStrategy.FACEBOOK);
				console.log(result);
			} catch (e) {
				console.error(e);
			}
			this.loading = false;
		}
	}

	async signUpWithApple() {
		if (this.agbChecked && !this.loading) {
			this.loading = true;
			try {
				console.log('Starting signUp with Apple');
				const result = await Api.signIn(AuthStrategy.APPLE);
				if (result && result.data) {
					var ua = navigator.userAgent.toLowerCase();

					if (ua.indexOf('safari') != -1) {
						if (ua.indexOf('chrome') > -1) {
							window.open(result.data.url, '_blank');
						} else {
							window.location.assign(result.data.url);
						}
					}
					// if (AppComponent.largeScreen) {
					//
					// } else {
					// 	window.location.assign(result.data.url)
					// }
				}
			} catch (e) {
				console.error(e);
			}
			this.loading = false;
		}
	}

	openTerms() {
		window.open('/tos', '_blank');
	}

	openPrivacy($event?: Event) {
		if ($event) {
			$event.stopPropagation();
		}
		window.open('/privacy', '_blank');
	}

	goBack() {
		if (this.repository._order === null) {
			this.navigationService.home();
		} else {
			this.navigationService.menu();
		}
	}
	gotoNextField(nextElement: IonInput) {
		nextElement.setFocus();
	}
	getErrorsForm(controlName) {
		if (controlName) {
			return this.signUpForm.get('phone').errors;
		}

		return null;
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}

	onPhoneBlur() {
		this.signUpForm.get(this.phone)?.markAsTouched();
	}

	markFormFieldsAsTouched(form: FormGroup) {
		Object.keys(form.controls).forEach(field => {
			const control = form.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.markFormFieldsAsTouched(control);
			}
		});
	}
}
